import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_5'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_5',
  name: "Which of the following topics are included within the facility's written policies and procedures for working hours?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'REGULAR_HOURS',
      text: 'Regular hours',
      externalIds: [
        {
          id: 'ms-1--7-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OVERTIME_INCLUDING_MAXIMUM_HOURS_POSSIBLE',
      text: 'Overtime - Including maximum hours possible',
      externalIds: [
        {
          id: 'ms-1--7-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PREMIUM_RATES',
      text: 'Premium rates',
      externalIds: [
        {
          id: 'ms-1--7-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OVERTIME_APPLICABILITY_AND_CORRESPONDING_RATES_OF_PAY',
      text: 'Overtime applicability and corresponding rates of pay',
      externalIds: [
        {
          id: 'ms-1--7-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OVERTIME_ACCESSIBILITY_FOR_ALL_WORKERS',
      text: 'Overtime accessibility for all workers',
      externalIds: [
        {
          id: 'ms-1--7-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--7-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--7-6f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'REGULAR_HOURS',
                'OVERTIME_INCLUDING_MAXIMUM_HOURS_POSSIBLE',
                'PREMIUM_RATES',
                'OVERTIME_APPLICABILITY_AND_CORRESPONDING_RATES_OF_PAY',
                'OVERTIME_ACCESSIBILITY_FOR_ALL_WORKERS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-20',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19310,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
